import React, { useEffect, useState, useCallback } from 'react';

import {
  SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_GET,
  SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_SET,
} from 'api/utilityActionTypes';

import useDispatch from 'client/hooks/useDispatch';
import requestUtilityApi from 'client/actions/requestUtilityApi';

import SrButton, { SR_BUTTON_THEME_ADOBE_YELLOW } from 'client/components/SrButton/SrButton';

const UPButtonMissingInternetPlanVariants = () => {
  const dispatch = useDispatch();
  const [cronJobStatus, setCronJobStatus] = useState(null);

  const getCronJobStatus = useCallback(() => {
    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_GET,
      onSuccess: (cronJobStatus) => setCronJobStatus(cronJobStatus),
    });
  }, [dispatch]);

  const toggleCronJobStatus = useCallback(() => {
    const newCronJobStatus = cronJobStatus === 'stopped' ? 'running' : 'stopped';

    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_SET,
      payload: { status: newCronJobStatus },
      onSuccess: () => setCronJobStatus(newCronJobStatus),
    });
  }, [dispatch, cronJobStatus]);

  useEffect(() => {
    getCronJobStatus();
  }, [getCronJobStatus]);

  return (
    <SrButton
      type="button"
      onClick={toggleCronJobStatus}
      theme={SR_BUTTON_THEME_ADOBE_YELLOW}
      margin="0 0 20px"
    >
      {cronJobStatus === 'stopped' ? 'Start' : 'Stop'} utilityMissingInternetPlanVariations Cron Job
    </SrButton>
  );
};

export default UPButtonMissingInternetPlanVariants;
